<template>
	<div>
		<div class="position-relative card-nodes">
			<v-menu open-on-hover offset-x nudge-left="-15" nudge-bottom="0" transition="scale-transition" content-class="elevation-0">
				<template v-slot:activator="{ on, attrs }">
					<div class="node node-filled all-node" v-bind="attrs" v-on="on" @click="generateGene(data.network_code)">
						<div class="node-image d-flex justify-center">
							<div class="hexa">
								<img :src="(data.member_image) ? data.member_image : 'assets/image/profile-pict.png'">
							</div>
						</div>

						<div class="node-data">
							<div class="pb-0 node-info text-left">
								<div class="font-size-8 cl-primary text-uppercase font-weight-600 genealogy-name">{{ (data.member_name !== undefined) ? ((data.member_name.length > 13) ? data.member_name.substring(0, 13) + '...' : data.member_name ) : 'ROOT' }}</div>
								<div class="font-size-8 cl-grey">{{ (data.network_code !== undefined ? data.network_code : '-') }}</div>
							</div>

							<div class="d-flex justify-left node-growth">
								<div class="font-size-8 cl-secondary text-uppercase">{{ data.network_type }}</div>
							</div>
						</div>
					</div>
				</template>

				<v-list class="menu-node">
					<v-list-item>
						<v-card class="elevation-0" width="250">
							<div class="font-size-12 text-uppercase cl-primary font-weight-600">{{ data.member_name }}</div>
							<div class="pt-1 d-flex justify-space-between">
								<div class="d-block w-100 font-size-8 cl-grey">
									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Kode Mitra</span>
										<div class="" :class="(data.network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
											<span class="font-weight-500" :class="(copyText === data.network_code) ? 'cl-secondary' : 'cl-primary'">{{ data.network_code }}</span>
											<template v-if="data.network_code !== ''">
												<v-btn
													color="secondary"
													x-small
													outlined
													title="Salin Kode Mitra"
													class="ml-1 px-1"
													style="width: 24px;min-width: 24px;"
													@click="copyThis(data.network_code)"
												><v-icon x-small>mdi-content-copy</v-icon></v-btn>
											</template>
										</div>
									</div>

									<div class="mb-5 d-flex align-center justify-space-between w-100">
										<span>Kode Sponsor</span>
										<div class="" :class="(data.network_sponsor_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
											<span class="font-weight-500" :class="(copyText === data.network_sponsor_network_code) ? 'cl-secondary' : 'cl-primary'">{{ data.network_sponsor_network_code | emptyData }}</span>
											<template v-if="data.network_sponsor_network_code !== ''">
												<v-btn
													color="secondary"
													x-small
													outlined
													title="Salin Kode Sponsor"
													class="ml-1 px-1"
													style="width: 24px;min-width: 24px;"
													@click="copyThis(data.network_sponsor_network_code)"
												><v-icon x-small>mdi-content-copy</v-icon></v-btn>
											</template>
										</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Bergabung</span>
										<div class="font-weight-500 black--text">{{ data.network_activation_datetime | tanggal }}</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Peringkat</span>
										<div class="font-weight-600 text-uppercase cl-primary">{{ data.network_type }}</div>
									</div>

								</div>
							</div>
						</v-card>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			copyText: ''
		}
	},
	props: {
		data: { type: Object }
	},
	methods: {
		...mapActions('network', ['getGenealogy']),

		getGene(code) {
			if ( this.clickable == true ) {
				this.getGenealogy({parent: code, limit: 10, offset: 0}).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			}
		},
		async generateGene(kode) {
			await this.$emit('action', kode)
		},
		goRegis(upline, position) {
			this.$router.push({ path: 'registrasi-mitra', query: { upline: upline, position: position }})
		},
		copyThis(text) {
			this.copyText = text
			const el = document.createElement('textarea')
			el.value = text
			document.body.appendChild(el)
			el.select()
			document.execCommand('copy')
			document.body.removeChild(el)
		},
		setNodeClass(type) {
			if (type === 'silver') return 'silver-node'
			else if (type === 'gold') return 'gold-node'
			else if (type === 'diamond') return 'diamond-node'
			else return 'silver-node'
		},
		setPointClass(type) {
			if (type === 'silver') return '/theme/image/genealogy/ic-node-silver.svg'
			else if (type === 'gold') return '/theme/image/genealogy/ic-node-gold.svg'
			else if (type === 'diamond') return '/theme/image/genealogy/ic-node-diamond.svg'
			else return '/theme/image/green/ic-node.svg'
		},
	},
};
</script>

<style lang="scss" scoped>
	.card-nodes {
		margin: 3px 0;
    width: 170px;
	}

	.all-node {
		display: flex;
		flex-direction: row;
    align-items: center;
		height: 55px;
    width: 100%;
		padding: 8px;
    position: relative;
    border: 1px solid #888888;
		/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,f6f6f6+47,ededed+100;White+3D+%231 */
		background: #ffffff; /* Old browsers */
		background: -moz-linear-gradient(top,  #ffffff 0%, #f6f6f6 47%, #ededed 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(top,  #ffffff 0%,#f6f6f6 47%,#ededed 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to bottom,  #ffffff 0%,#f6f6f6 47%,#ededed 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ededed',GradientType=0 ); /* IE6-9 */
	}

	.node-data {
		display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    padding-left: 0px;
		position: relative;

		.node-item-control {
			position: absolute;
			right: -85px;
			top: 23%;

			.v-btn {
				width: 32px!important;
				height: 32px!important;
			}

			&::before {
				height: 1px;
				display: block;
				width: 65px;
				border-top: 1px dotted #888;
				position: absolute;
				left: -35px;
				top: 50%;
				z-index: 0;
				content: "";
			}
		}
	}
</style>